import React from 'react';

const ErrorPage = () => {
  return ( 
    <div className='d-flex justify-content-center text-light'>
      <h1 className='mt-5 error-page'>Page Not found</h1>
    </div>
  );
}
 
export default ErrorPage;